import React from "react";
import OrderTable from "../Table";

const PaymentFailed = () => {
  return <OrderTable type="failed" />;
};

export default PaymentFailed;
